import { ReactElement, useEffect, useState } from "react";
import { useLoaders } from "@/providers";
import { AppRoutingSetup } from ".";

const AppRouting = (): ReactElement => {
  const { setProgressBarLoader } = useLoaders();
  const [previousLocation,] = useState("");
  // const location = useLocation();
  // const path = location.pathname.trim();

  useEffect(() => {
    setProgressBarLoader(false);

    // Scroll to page top on route change if URL does not contain a hash
    if (!CSS.escape(window.location.hash)) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [previousLocation]);

  return <AppRoutingSetup />;
};

export { AppRouting };
